import * as c from './Consts';

export const openNewTabWithChecklist = () => {
    window.open(process.env.PUBLIC_URL + "/" + c.filename_download_checklist, '_blank');
}

export function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
}
